const Heading3 = (props: React.HTMLAttributes<HTMLHeadingElement>) => {
  return <h3 className="text-lg font-semibold text-blue-500">{props.children}</h3>;
};

export default Heading3;
